import React from 'react';
import { useIntl } from 'react-intl';
import { useForm } from 'react-hook-form';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';

import Form, { FormTextField } from '@ts-core/core/components/FormV2';

import LoginFormHeader from '../LoginForm/LoginFormHeader';

import { SetNewPasswordInput } from '../../types/Auth';

const SetNewPasswordFormSchema = Yup.object({
  password: Yup.string().required('Ingresa la nueva contraseña'),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref('password'), null], 'Las contraseñas no coinciden')
    .required('Repite la nueva contraseña'),
});

interface SetNewPasswordFormProps {
  onSubmit: (input: SetNewPasswordInput) => void;
  isSubmitting?: boolean;
  submitError?: string;
}

const SetNewPasswordForm = (props: SetNewPasswordFormProps) => {
  const { onSubmit, isSubmitting = false, submitError } = props;
  const intl = useIntl();
  const { handleSubmit, formState, control } = useForm<SetNewPasswordInput>({
    resolver: yupResolver(SetNewPasswordFormSchema),
  });

  return (
    <Box width="100%">
      <Box boxShadow={1} bgcolor="background.paper" borderRadius="8px" px={3} display="flex" flexDirection="column" alignItems="center">
        <LoginFormHeader title={intl.formatMessage({ id: 'setNewPassword.title' })} />
        <Form
          sx={{ width: '100%', p: 2 }}
          onSubmit={handleSubmit(onSubmit)}
          isSubmitting={isSubmitting}
          submitError={submitError}
          formState={formState}
          submitButtonProps={{
            variant: 'text',
          }}
          submitActionTitle={intl.formatMessage({ id: 'setNewPassword.title' })}
          submitButtonAlignment="center"
        >
          <Stack spacing={2}>
            <FormTextField
              control={control}
              name="password"
              rules={{ required: true }}
              type="password"
              fullWidth
              label={intl.formatMessage({ id: 'field.password.label' })}
            />
            <FormTextField
              control={control}
              name="confirmPassword"
              rules={{ required: true }}
              type="password"
              fullWidth
              label={intl.formatMessage({ id: 'field.confirmPassword.label' })}
            />
          </Stack>
        </Form>
      </Box>
    </Box>
  );
};

export default SetNewPasswordForm;
